import Validation from '@core/logic/Validation'
import ECDD from '@master/model/kyc-form/ECDD'

export default class ECDDValidation extends Validation {
  validate (ecdd: ECDD, belongsTo: string) {
    this.belongsTo = belongsTo

    const { getMessages, ADD, REQUIRE, WHEN } = this.validator()

    ADD(REQUIRE(ecdd.highRiskCountry, 'From high risk country is required'), ['Enhanced Client Due Diligence Form'], ['highRiskCountry'])
    ADD(WHEN(ecdd.highRiskCountry === 'yes', REQUIRE(ecdd.stayInSg, 'Stay in Singapore is required when from high risk country is Yes')), ['Enhanced Client Due Diligence Form'], ['stayInSg'])
    ADD(WHEN(ecdd.highRiskCountry === 'yes' && ecdd.stayInSg === 'no', REQUIRE(ecdd.residingAddress, 'Residing address is required when stay in Singapore is No')), ['Enhanced Client Due Diligence Form'], ['residingAddress'])
    ADD(REQUIRE(ecdd.sourceOfFunds, 'Transaction is more than SGD$500,000 is required'), ['Enhanced Client Due Diligence Form'], ['sourceOfFunds'])
    ADD(WHEN(ecdd.sourceOfFunds === 'yes', REQUIRE(ecdd.sourceOfFunds2, 'Source of Funds is required when transaction is more than SGD$500,000')), ['Enhanced Client Due Diligence Form'], ['sourceOfFunds2'])
    ADD(WHEN(ecdd.sourceOfFunds === 'yes' && ecdd.sourceOfFunds2 === 'yes', REQUIRE(ecdd.sourceOfFunds2Info, 'Source of Funds details is required when Source of Funds is Yes')), ['Enhanced Client Due Diligence Form'], ['sourceOfFunds2Info'])
    ADD(REQUIRE(ecdd.additionalNote, 'Additional note is required'), ['Enhanced Client Due Diligence Form'], ['additionalNote'])

    return getMessages()
  }
}
